/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * Licensed under the MIT License. See LICENSE.md in the project root for license terms.
 *--------------------------------------------------------------------------------------------*/
/** List of post event messages that are sent from Design Review and need to be handled by the embedding app.
 */
export var IFrameParentEvents;
(function (IFrameParentEvents) {
    IFrameParentEvents["IModelQueryResult"] = "IModelQueryResult";
    IFrameParentEvents["SelectionChanged"] = "SelectionChanged";
    IFrameParentEvents["ElementProps"] = "ElementProps";
    IFrameParentEvents["SectionToolClipChanged"] = "SectionToolClipChanged";
    IFrameParentEvents["ViewOpened"] = "ViewOpened";
    IFrameParentEvents["UserStateChanged"] = "UserStateChanged";
    IFrameParentEvents["CustomEvent"] = "CustomEvent";
})(IFrameParentEvents || (IFrameParentEvents = {}));
/** List of post event messages that can be sent to Design Review and will perform a specific action.
 */
export var IFrameCommands;
(function (IFrameCommands) {
    /** IModel events */
    IFrameCommands["IModelQuery"] = "IModelQuery";
    /** Given a list of element ids, Design Review will use this event to drive a Unified Selection event within Design Review */
    IFrameCommands["SelectElements"] = "SelectElements";
    IFrameCommands["GetElementInfo"] = "GetElementInfo";
    /** Viewport events */
    IFrameCommands["ZoomElements"] = "ZoomElements";
    /** EmphasizeElements events */
    IFrameCommands["EmphasizeElements"] = "EmphasizeElements";
    IFrameCommands["OverrideElements"] = "OverrideElements";
    IFrameCommands["ClearOverriddenElements"] = "ClearOverriddenElements";
    IFrameCommands["EmphasizeAndZoomElements"] = "EmphasizeAndZoomElements";
    IFrameCommands["ClearEmphasizedElements"] = "ClearEmphasizedElements";
    /** SectionRange events */
    IFrameCommands["ShowSectionRange"] = "ShowSectionRange";
    IFrameCommands["ClearSectionRange"] = "ClearSectionRange";
    /** Load iModel.js Extension */
    IFrameCommands["LoadExtension"] = "LoadExtension";
    /** User events */
    IFrameCommands["ForceRefresh"] = "ForceRefresh";
    /** Support custom messages */
    IFrameCommands["CustomMessage"] = "CustomMessage";
})(IFrameCommands || (IFrameCommands = {}));
//# sourceMappingURL=Events.js.map